import React, { useState, useEffect } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
} from 'reactstrap';
import { Bell, Users, BarChart2, Calendar } from 'lucide-react';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import NotificationForm from '../../components/NotifSignalComponents/NotificationForm';
import NotificationList from '../../components/NotifSignalComponents/NotificationList';
import UserManagement from '../../components/NotifSignalComponents/UserManagement';
// import Analytics from '../../components/NotifSignalComponents/Analytics';
import { initOneSignal } from '../../Services/oneSignalService';
import { withTranslation } from 'react-i18next';

const SignalNotifications = ({ t }) => {
  const [activeTab, setActiveTab] = useState('1');

  useEffect(() => {
    initOneSignal();
  }, []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            maintitle={t('Home')}
            title={t('Data')}
            breadcrumbItem={t('Exercises Videos')}
          />

          <Nav tabs>
            <NavItem>
              <NavLink
                className={`nav-link ${activeTab === '1' ? 'active' : ''}`}
                onClick={() => toggleTab('1')}
              >
                <Bell className="me-2 h-4 w-4" />
                {t('Create Notification')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`nav-link ${activeTab === '2' ? 'active' : ''}`}
                onClick={() => toggleTab('2')}
              >
                <BarChart2 className="me-2 h-4 w-4" />
                {t('Sent Notifications')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`nav-link ${activeTab === '3' ? 'active' : ''}`}
                onClick={() => toggleTab('3')}
              >
                <Users className="me-2 h-4 w-4" />
                {t('User Management')}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} className="mt-3">
            <TabPane tabId="1">
              <Card>
                <CardBody>
                  <CardTitle tag="h5">{t('Create Notification')}</CardTitle>
                  <CardSubtitle className="mb-2 text-muted">
                    {t('Compose and send a new notification to your users.')}
                  </CardSubtitle>
                  <NotificationForm />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId="2">
              <Card>
                <CardBody>
                  <CardTitle tag="h5">{t('Sent Notifications')}</CardTitle>
                  <CardSubtitle className="mb-2 text-muted">
                    {t('View and manage your sent notifications.')}
                  </CardSubtitle>
                  <NotificationList />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId="3">
              <Card>
                <CardBody>
                  <CardTitle tag="h5">{t('User Management')}</CardTitle>
                  <CardSubtitle className="mb-2 text-muted">
                    {t('Manage your users and send individual notifications.')}
                  </CardSubtitle>
                  <UserManagement />
                </CardBody>
              </Card>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(SignalNotifications);
